import Cart from "../partials/woocommerce-cart";

const QuickCart = {
  element: $(".quick-cart"),

  init() {
    QuickCart.events();
  },

  /**
   * Open QuickCart
   **/
  open() {
    $(".quick-cart").addClass("quick-cart--open");
    $("html").addClass("no-scroll");
    $(".screen-overlay").addClass("menu-visible").addClass('quick-cart-open');
    if( ! $(".quick-cart").hasClass("quick-cart--loaded") ) {
      $(".preloader").addClass("preloader--show");
    }
  },

  /**
   * Close QuickCart
   **/
  close() {
    $(".quick-cart").removeClass("quick-cart--open");
    $(".screen-overlay").removeClass("menu-visible").removeClass('quick-cart-open');
    $("html").removeClass("no-scroll");
  },

  loading() {
    $('#quick-cart').html('');
    $(".quick-cart").removeClass("quick-cart--loaded");
    $(".preloader").addClass("preloader--show");
  },

  /**
   * Loaded QuickCart
   **/
  loaded() {
    $(".quick-cart").addClass("quick-cart--loaded");
    $(".preloader").removeClass("preloader--show");
  },

  /**
   * QuickCart functionality
   **/
  events() {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const quickCart = urlParams.get('qc');

    if ( '1' === quickCart ) {
      QuickCart.render();
      urlParams.delete('qc');
    }

    $(".open-cart").on("click", function (e) {
      e.preventDefault();

      switch (true) {
        case $(".quick-cart").hasClass("quick-cart--open"):
          QuickCart.close();
          break;

        case $(".quick-cart").hasClass("quick-cart--loaded"):
          QuickCart.open();
          break;

        default:
          QuickCart.render();
          break;
      }
    });

    $(".quick-cart").on("click", ".quick-cart__close", function () {
      QuickCart.close();
    });

    $(document).keyup(function (e) {
      if ($(".quick-cart").hasClass("quick-cart--loaded")) {
        if (e.keyCode === 27) {
          QuickCart.close();
        }
      }
    });

    $(document).on('click', '.quick-cart-remove', function(e) {
      e.preventDefault();
      QuickCart.removeItem ( $(this).parent().parent().find('input') );
    });

    $(document).mouseup(function (e) {
      if ($(".quick-cart").hasClass("quick-cart--loaded")) {
        var container = $(".quick-cart").find(".quick-cart__inner");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          QuickCart.close();
        }
      }
    });

    let timeout;
    $('body').on("change", "input.quick-cart-input", function() {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        QuickCart.loading();
        Cart.updateQuantity( $(this) );
      }, 1000);
    })
  },

  /**
   * Render quickcart
   **/
  render() {
    QuickCart.open();
    // $(".quick-cart").html('<div class="quick-cart__loader"></div>');

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "render_quick_cart",
      },
    }).done((response) => {
      if (response) {
        QuickCart.loaded();
        $("#quick-cart").html(response);
      } else {
        QuickCart.close();
      }
    });
  },

  removeItem( input ) {
    let regex = /cart\[(.*?)\]\[qty\]/;
    let found = input.attr("name").match(regex);
    if (!found[1]) {
      return;
    }
    let item_key = found[1];

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "update_cart_item_quantity",
        item_key: item_key,
        qty: 0,
      },
    }).done((response) => {
      if (response) {
        QuickCart.render();
      }
    });
  }
};

export default QuickCart;
